'use strict';

import { MAXWELL_IA_GENERAR_URL, MAXWELL_IA_ERROR } from '../../Screens/MaxwellIA/actions/Actions';

const initialState = {
    ssoUrl:       null,
    error:        null,
    mostrarModal: false,
    modalMensaje: ""
};

function maxwellIA(state = initialState, action) {
    switch (action.type) {
        case MAXWELL_IA_GENERAR_URL:
            return { ...state, ssoUrl: action.ssoUrl, error: null };

        case MAXWELL_IA_ERROR:
            return { ...state, ssoUrl: null, error: action.mensaje };

        case 'MAXWELL_IA_MOSTRAR_MODAL':
            return { ...state, mostrarModal: action.mostrarModal };

        default:
            return { ...state };
    }
}

export default maxwellIA;
